import React from 'react';
import { StyledArrowDownIcon, StyledArrowUpIcon, StyledStepper, StyledStepperIcons, StyledStepperInput } from './Stepper.styled';
export function Stepper(props) {
  var currentValue = Number(props.value);
  var onChange = function onChange(e) {
    var newValue = e.currentTarget.value.trim();
    var numberValue = newValue ? parseInt(newValue, 10) : null;
    props.onChange(numberValue);
  };
  var increaseValue = function increaseValue() {
    if (currentValue >= props.maxValue) {
      props.onBlur(props.minValue);
      return;
    }
    props.onBlur(currentValue + 1);
  };
  var decreaseValue = function decreaseValue() {
    if (currentValue <= props.minValue) {
      props.onBlur(props.maxValue);
      return;
    }
    props.onBlur(currentValue - 1);
  };
  var onKeyDown = function onKeyDown(e) {
    if (e.key === 'ArrowUp') {
      e.preventDefault();
      increaseValue();
    }
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      decreaseValue();
    }
  };
  return /*#__PURE__*/React.createElement(StyledStepper, null, /*#__PURE__*/React.createElement(StyledStepperInput, {
    type: "number",
    step: 1,
    "aria-label": props['aria-label'],
    placeholder: props.placeholder,
    value: padStart(props.value, props.leadingZero ? 2 : 1),
    onChange: onChange,
    onBlur: function onBlur() {
      return props.onBlur(props.value);
    },
    onKeyDown: onKeyDown
  }), /*#__PURE__*/React.createElement(StyledStepperIcons, null, /*#__PURE__*/React.createElement(StyledArrowUpIcon, {
    onClick: increaseValue,
    tabIndex: -1
  }), /*#__PURE__*/React.createElement(StyledArrowDownIcon, {
    onClick: decreaseValue,
    tabIndex: -1
  })));
}
function padStart(value, digits) {
  if (value == null) {
    return '';
  }
  var valueString = value.toString();
  var padString = '0';
  if (valueString.length >= digits) {
    return valueString;
  } else {
    digits = digits - valueString.length;
    if (digits > padString.length) {
      padString += padString.repeat(digits / padString.length);
    }
    return padString.slice(0, digits) + valueString;
  }
}